import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import RichText from '../ui/RichText'

function FAQItem({ question, answer, items, answerEnd, isOpen, onClick }) {
  return (
    <div className="border-b border-black/10 mb-20">
      <button
        onClick={onClick}
        className="w-full flex justify-between items-center text-left hover:opacity-70 transition-opacity mb-20"
      >
        <span className="text-lato-regular text-lg flex-1">{question}</span>
        <span className="text-2xl ml-20 flex-shrink-0">{isOpen ? '−' : '+'}</span>
      </button>

      {isOpen && (
        <div className="mt-12 pb-12">
          <RichText text={answer} className="text-lato-regular" />
          {items && items.length > 0 && (
            <ul className="list-disc pl-24 my-10 space-y-8">
              {items.map((item, index) => (
                <li key={index} className="text-lato-regular">{item}</li>
              ))}
            </ul>
          )}
          {answerEnd && (
            <RichText text={answerEnd} className="text-lato-regular" />
          )}
        </div>
      )}
    </div>
  )
}

function FAQ() {
  const { t } = useTranslation()
  const questions = t('pages.home.sections.faq.questions', { returnObjects: true })
  const [openIndex, setOpenIndex] = useState(null)

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index)
  }

  return (
    <section className="section-container bg-beige py-80 px-20 tablet:px-32">
      <div className="w-full max-w-[800px] mx-auto">
        <h2 className="text-lato-bold text-[32px] mb-40">
          {t('pages.home.sections.faq.heading')}
        </h2>

        <div className="flex flex-col gap-8">
          {questions.map((item, index) => (
            <FAQItem
              key={index}
              question={item.question}
              answer={item.answer}
              items={item.items}
              answerEnd={item.answerEnd}
              isOpen={openIndex === index}
              onClick={() => handleToggle(index)}
            />
          ))}
        </div>
      </div>
    </section>
  )
}

export default FAQ
